import BookCard from 'core/modules/components/cards/BookCard';
import PropTypes from 'prop-types';
import AddLicenseForm from 'core/modules/components/forms/AddLicenseForm';
import BasicList from 'core/modules/components/lists/components/BasicList';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import IconBubble from 'ui/molecules/IconBubble/IconBubble';
import Loading from 'ui/atoms/Loading/Loading';

const DialogRedeem = ({ t, open, onClose, onSubmit, errorLicense, errorMsg, loading, redeemedLicense, configProgramPicture }) => {
  const [title, setTitle] = useState(t('Enter your code'));

  useEffect(() => {
    if (!redeemedLicense) setTitle(t('Enter your code'));
    else if (redeemedLicense && redeemedLicense.type === 'SCHOOL_GROUP') setTitle(t('my-courses:Great you joined this classroom'));
    else if (redeemedLicense && redeemedLicense.type === 'PERSONAL_LICENSE') setTitle(t('my-courses:Great you added a program'));
  }, [redeemedLicense]);

  return (
    <Dialog title={title} isOpen={open} className={'dialog-add-license home'} onClose={onClose}>
      <div className="dialog-add-license__content">
        {redeemedLicense ? (
          <div className="dialog-add-license__group-success">
            {redeemedLicense.type === 'SCHOOL_GROUP' && (
              <>
                <div className="dropdown-courses__bubbles">
                  <IconBubble size="xxl" name="presentation" />
                </div>
                <div className="dialog-courses__info">
                  <div className="dialog-courses__name">{redeemedLicense.school_group && redeemedLicense.school_group.name}</div>
                  <div className="dialog-courses__level">
                    {redeemedLicense.school_group && redeemedLicense.school_group.education_year_name}{' '}
                    {redeemedLicense.school_group && redeemedLicense.school_group.education_level_name}
                  </div>
                </div>
              </>
            )}
            {redeemedLicense.type === 'PERSONAL_LICENSE' && (
              <div className="dialog-courses__info">
                <BasicList
                  items={redeemedLicense.programs.map((program, index) => (
                    <BookCard
                      key={program.program?.guid ?? index}
                      image={program.program?.picture}
                      title={program.program?.name}
                      useWindow={false}
                      view="view"
                      subText={program.education_year?.name + ' ' + program.education_level?.name}
                      courseName={program.education_year?.name + ' ' + program.education_level?.name}
                      configProgramPicture={configProgramPicture}
                    />
                  ))}
                />
              </div>
            )}
          </div>
        ) : (
          <AddLicenseForm error={errorLicense} errorMsg={errorMsg} label={t('Add your class key or a licence code')} onSubmit={onSubmit} />
        )}
      </div>
      {loading && <Loading />}
    </Dialog>
  );
};

DialogRedeem.propTypes = {
  configProgramPicture: PropTypes.bool,
  errorLicense: PropTypes.bool,
  errorMsg: PropTypes.string,
  loading: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  open: PropTypes.bool,
  redeemedLicense: PropTypes.shape({
    programs: PropTypes.array,
    school_group: PropTypes.shape({
      education_level_name: PropTypes.string,
      education_year_name: PropTypes.string,
      name: PropTypes.string,
    }),
    type: PropTypes.string,
  }),
  t: PropTypes.func.isRequired,
};

DialogRedeem.defaultProps = {
  onClose: function () {},
  open: false,
};

export default withTranslation('my-courses')(DialogRedeem);
